var LazyLoad = function() {
    $("img").each(function(){
        if($(this).data("src") && $(this).data("src").match(/\/http/))
        {
            $(this).attr("data-src", $(this).data("src").replace(/\/http/, "http"));
            console.log($(this).attr("data-src"));
        }
    });

    this.init = function(){
        $("img").unveil(300);
    };

    function loadVideo() {
        setTimeout(function(){
            $(".yt-video").find("iframe").each(function(_, iframe){
                iframe.src = $(iframe).data("src");
            });
        }, 10);
    }

    if($(".yt-video").length)
    {
        $(window).on("scroll.Youtube", function(){
            if($(window).scrollTop() > $(".yt-video").offset().top - window.innerHeight - 100) {
                $(window).off("scroll.Youtube");
                loadVideo();
            }
        });
    }

    $(window).on("resize.mobilebanner", function(){
        if($(document).width() < 768) {
            if(window.devicePixelRatio > 1) {
                $(".mobile-banner").css({
                    "background-image": "url(" + $(".mobile-banner").data("background-2x") + ")"
                });
            }
            $(window).off("resize.mobilebanner");
        }
    });

    $(window).on("resize.desktopbanner", function(){
        if($(document).width() >= 768 && $(".banner").data("background")) {
            $(".banner:not(.banner-new)").css({
                "background-image": "url(" + $(".banner").data("background") + ")"
            });
            $(window).off("resize.desktopbanner");
        }
    });

    $(window).trigger("resize");
    
    $(".always-load").each(function(){
        $(this).attr("src", $(this).data("src"));
        if($(this).attr("srcset"))
        {
            $(this).attr("srcset", $(this).data("srcset"));
        }
    });
};
module.exports = LazyLoad;
